import Router from 'next/router';
import { captureException } from '@sentry/nextjs';
import * as actionTypes from 'src/modules/community/poll/actionTypes';
import api, { createAuthenticatedApiInstance } from 'src/utils/api';
import { enrichDataObject } from 'src/utils/enrichDataObject';
import { setAlert } from 'src/components/alert/actions';
import i18n from 'src/utils/translate';

export const fetchPoll = (pollId, communitySlug) => async (dispatch, getState) => {
  dispatch({ type : actionTypes.POLL_FETCH });
  try {
    const api = createAuthenticatedApiInstance(getState);
    const currentUser = getState().context.currentUser;

    const { data } = currentUser?.isCommunityMemberOrHUStaff
      ? await api.get(`private/polls/${communitySlug}/${pollId}`)
      : await api.getPublic(`polls/${communitySlug}/${pollId}`);

    const responses = (data.responses || []).map(response => enrichDataObject(response, data.mentionedUsers));
    dispatch({
      type: actionTypes.POLL_FETCH_SUCCESS,
      post: {
        ...data,
        responses,
      },
    });

  } catch (ex) {
    captureException(ex);
    dispatch({ type: actionTypes.POLL_FETCH_FAILURE, error: ex });
    dispatch(setAlert());
  }
};

export const pollVote = (
  pollId: number,
  communitySlug: string,
  choices: string[],
) => async (dispatch, getState) => {
  dispatch({ type: actionTypes.POLL_VOTE });
  try {
    const api = createAuthenticatedApiInstance(getState);
    const { status } = await api.post(`private/polls/${communitySlug}/${pollId}/vote`, choices);

    if (status !== 200) {
      throw Error('Error: Poll vote failed');
    }

    dispatch({ type: actionTypes.POLL_VOTE_SUCCESS });
    dispatch(fetchPoll(pollId, communitySlug));
  } catch (ex) {
    captureException(ex);
    dispatch({ type: actionTypes.POLL_VOTE_FAILURE, error: ex });
    dispatch(setAlert());
  }
};

export const pollResultsShow = () => async (dispatch) => {
  dispatch({ type: actionTypes.POLL_RESULTS_SHOW });
};

export const pollResultsHide = () => async (dispatch) => {
  dispatch({ type: actionTypes.POLL_RESULTS_HIDE });
};

export const pollChangeVote = () => async (dispatch) => {
  // TODO: Update Aurora endpoint to allow for user vote to be changed
  dispatch({ type: actionTypes.POLL_CHANGE_VOTE });
};

export const deletePoll = (postId: number, communitySlug: string) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.DELETE_POLL });
    try {
      const { status } = await api.del(`private/polls/${communitySlug}/${postId}`);

      if (status !== 200) {
        throw Error('Error: Poll delete failed');
      }

      dispatch({ type: actionTypes.DELETE_POLL_SUCCESS });
      dispatch(setAlert(i18n.t('Poll successfully removed.'), 'success'));

      Router.push(
        `/community/communityHome?communitySlug=${communitySlug}`,
        `/${communitySlug}`,
      );
    } catch (ex) {
      captureException(ex);
      dispatch({ type: actionTypes.DELETE_POLL_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};
